<template>
    <div>
        <!-- ERROR! -->
        <div class="rounded-md bg-red-50 p-4 mt-4" v-if="donationCancel">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                            clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-red-800">ERROR!</h3>
                    <div class="mt-2 text-sm text-red-700">
                        <ul role="list" class="list-disc space-y-1 pl-5">
                            <li> Your payment was canceled</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- Payment successful! -->
        <div class="rounded-md bg-green-50 p-4 mt-4" v-if="donationSuccess">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                            clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-green-800">Payment successful! </h3>
                    <div class="mt-2 text-sm text-green-700">
                        <p> Your payment has been completed successfully.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Attention -->
        <div class="rounded-md shadow-sm bg-yellow-100 p-3 mb-4 mt-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400 mt-px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                        fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                    <p class="text-sm font-medium text-yellow-700">
                        This document gives the appraisal district permission to negotiate with Chandler Crouch and do all
                        tasks necessary to complete your protest.
                        Click the button below to sign the form electronically.
                    </p>
                </div>
            </div>
        </div>

        <div class="bg-white p-3 border text-center tracking-wide">
            <div class="grid grid-cols-2 gap-3" v-if="userProperty.authorize_signature">
                <a href="javascript:void(0);" @click="openAddSignatureModal()"
                    class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 font-medium text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 hidden sm:inline-flex" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                        <path fill-rule="evenodd"
                            d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                            clip-rule="evenodd" />
                    </svg>
                    Change Signature
                </a>

                <a :href="siteUrl + '/protest-requests/' + userProperty.protest_request_uid + '/complete'"
                    class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-yellow-500 font-medium text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 text-sm">
                    Complete Request
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1 hidden sm:inline-flex" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                    </svg>
                </a>
            </div>

            <a href="javascript:void(0);" v-if="!userProperty.authorize_signature" @click="openAddSignatureModal()"
                class="w-full tracking-wide inline-block px-2 sm:px-6 py-2 border border-transparent font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <svg width="56" height="56" viewBox="0 0 56 56" fill="#fff" xmlns="http://www.w3.org/2000/svg"
                    class="inline-block w-5 h-5 align-text-bottom">
                    <path
                        d="M33.7171 12.3764H40.8892L40.8899 20.744L44.526 15.0983V10.3657C44.526 10.0767 44.411 9.79947 44.2066 9.59413L34.9314 0.319333C34.727 0.115067 34.4496 0 34.16 0H5.48192C3.67738 0 2.20898 1.46773 2.20898 3.2724V52.7276C2.20898 54.5321 3.67725 56 5.48192 56H41.253C43.0574 56 44.5256 54.5321 44.5256 52.7276V38.6867L40.8904 44.2495L40.891 52.3633H5.84552V3.63653H32.3663V11.0255C32.3663 11.772 32.971 12.3764 33.7171 12.3764Z" />
                    <path
                        d="M48.5868 26.0164L47.084 25.0345C46.8387 24.8744 46.5103 24.9431 46.3499 25.1884L38.2581 37.5705L36.7021 36.5539L44.7939 24.1716C44.9543 23.9261 44.8855 23.5977 44.6401 23.4375L43.1373 22.4555C42.892 22.2952 42.5633 22.364 42.4032 22.6093L30.2873 41.1497C30.2358 41.2285 30.2064 41.3196 30.2016 41.4136L29.8849 47.848C29.8757 48.0359 29.9668 48.2152 30.1245 48.3177C30.2822 48.4208 30.4829 48.4324 30.651 48.3485L36.4168 45.4748C36.5013 45.4331 36.5728 45.3691 36.6245 45.2901L48.7401 26.7499C48.9009 26.5053 48.8319 26.1768 48.5868 26.0164Z" />
                    <path
                        d="M53.5508 18.4193L48.1016 14.8583C47.8565 14.6981 47.5277 14.7669 47.3675 15.0121L43.6924 20.636C43.5323 20.8813 43.6009 21.2101 43.8463 21.3704L49.2955 24.9312C49.5405 25.0915 49.8694 25.0227 50.0296 24.7773L53.7045 19.1536C53.865 18.9083 53.7961 18.5796 53.5508 18.4193Z" />
                    <path
                        d="M11.1419 11.6616H21.5419C22.2783 11.6616 22.8753 11.0645 22.8753 10.3283C22.8753 9.59199 22.2783 8.99492 21.5419 8.99492H11.1419C10.4055 8.99492 9.80859 9.59199 9.80859 10.3283C9.80859 11.0645 10.4058 11.6616 11.1419 11.6616Z" />
                    <path
                        d="M30.8753 16.9949C30.8753 16.2587 30.2781 15.6616 29.5419 15.6616H11.1419C10.4055 15.6616 9.80859 16.2587 9.80859 16.9949C9.80859 17.7312 10.4055 18.3283 11.1419 18.3283H29.5419C30.2783 18.3283 30.8753 17.7312 30.8753 16.9949Z" />
                    <path
                        d="M11.1419 24.9949H21.5419C22.2783 24.9949 22.8753 24.3979 22.8753 23.6616C22.8753 22.9253 22.2783 22.3283 21.5419 22.3283H11.1419C10.4055 22.3283 9.80859 22.9253 9.80859 23.6616C9.80859 24.3979 10.4058 24.9949 11.1419 24.9949Z" />
                    <path
                        d="M11.1419 31.7167H21.5419C22.2783 31.7167 22.8753 31.1196 22.8753 30.3833C22.8753 29.6472 22.2783 29.05 21.5419 29.05H11.1419C10.4055 29.05 9.80859 29.6472 9.80859 30.3833C9.80859 31.1196 10.4058 31.7167 11.1419 31.7167Z" />
                    <path
                        d="M11.7062 48.9476C11.4466 49.2831 11.9149 49.7585 12.1777 49.4187C13.0061 48.3485 13.6902 47.1959 14.2615 45.9793C14.6181 46.2032 15.0862 46.1584 15.4702 46.0067C16.0237 45.7884 16.4929 45.3672 16.9397 44.986C17.2038 44.7607 17.5113 44.3885 17.8769 44.3529C18.1561 44.3261 18.5331 44.5509 18.8122 44.5988C19.5414 44.7231 20.3931 44.512 21.0971 44.338C21.7653 44.1731 22.5477 43.9121 22.9409 43.3072C23.1759 42.9456 22.5985 42.6117 22.3653 42.9711C22.0505 43.4553 21.2818 43.6063 20.7623 43.7345C20.1526 43.8853 19.4451 44.034 18.8167 43.9268C18.3431 43.8463 17.9601 43.5599 17.4731 43.7768C16.8209 44.0675 16.3226 44.6783 15.7466 45.0907C15.4889 45.2752 15.1943 45.4525 14.8719 45.4775C14.7393 45.4877 14.6311 45.4391 14.5413 45.358C14.6122 45.1935 14.6826 45.0281 14.7497 44.8613C15.3998 43.2475 15.6938 41.6085 15.9955 39.9085C16.1489 39.0447 16.4039 37.6835 15.1658 37.6004C14.0718 37.5273 13.1263 39.1053 12.7767 39.9369C12.4641 40.6807 12.4293 41.5447 12.4531 42.3388C12.4679 42.8337 12.6461 43.3476 12.7774 43.8593C11.7276 44.0277 10.8022 45.0881 10.9644 46.1393C11.124 47.1737 12.4174 46.6396 12.9005 46.2568C13.3894 45.8695 13.5477 45.3856 13.5529 44.8637C13.6503 45.0244 13.7318 45.2171 13.8161 45.3973C13.2527 46.6609 12.5465 47.862 11.7062 48.9476ZM12.8747 45.1741C12.7761 45.6139 12.2197 46.048 11.7815 46.0885C11.4369 46.1205 11.6471 45.5049 11.7153 45.3673C11.9291 44.9351 12.459 44.6529 12.9045 44.5313C12.9253 44.7483 12.9219 44.9632 12.8747 45.1741ZM13.4315 43.8833C13.3181 43.3532 13.1606 42.8208 13.1198 42.3389C13.0409 41.4089 13.2061 40.4344 13.6673 39.6211C13.9554 39.1128 14.5427 38.3339 15.1658 38.2672C15.7222 38.208 15.3829 39.5612 15.3347 39.8331C15.1858 40.6723 15.0795 41.5052 14.8719 42.3348C14.6791 43.1052 14.4349 43.8681 14.1427 44.6141C13.9874 44.2276 13.7851 43.9801 13.4315 43.8833Z" />
                </svg>
                Click here to sign the agreement
            </a>
        </div>

        <!-- <div class="bg-white shadow-md rounded sm:rounded-lg p-4"> -->
        <iframe :src="siteUrl + '/user-properties/' + userProperty.uid + '/load-aoa-template-for-signature'"
            class="w-full min-h-screen"></iframe>

        <div class="bg-white p-3 border text-center tracking-wide">
            <div class="grid grid-cols-2 gap-3" v-if="userProperty.authorize_signature">
                <a href="javascript:void(0);" @click="openAddSignatureModal()"
                    class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 font-medium text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 hidden sm:inline-flex" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                        <path fill-rule="evenodd"
                            d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                            clip-rule="evenodd" />
                    </svg>
                    Change Signature
                </a>

                <a :href="siteUrl + '/protest-requests/' + userProperty.protest_request_uid + '/complete'"
                    class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-yellow-500 font-medium text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 text-sm">
                    Complete Request
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1 hidden sm:inline-flex" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                    </svg>
                </a>
            </div>

            <a href="javascript:void(0);" v-if="!userProperty.authorize_signature" @click="openAddSignatureModal()"
                class="w-full tracking-wide inline-block px-2 sm:px-6 py-2 border border-transparent font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <svg width="56" height="56" viewBox="0 0 56 56" fill="#fff" xmlns="http://www.w3.org/2000/svg"
                    class="inline-block w-5 h-5 align-text-bottom">
                    <path
                        d="M33.7171 12.3764H40.8892L40.8899 20.744L44.526 15.0983V10.3657C44.526 10.0767 44.411 9.79947 44.2066 9.59413L34.9314 0.319333C34.727 0.115067 34.4496 0 34.16 0H5.48192C3.67738 0 2.20898 1.46773 2.20898 3.2724V52.7276C2.20898 54.5321 3.67725 56 5.48192 56H41.253C43.0574 56 44.5256 54.5321 44.5256 52.7276V38.6867L40.8904 44.2495L40.891 52.3633H5.84552V3.63653H32.3663V11.0255C32.3663 11.772 32.971 12.3764 33.7171 12.3764Z" />
                    <path
                        d="M48.5868 26.0164L47.084 25.0345C46.8387 24.8744 46.5103 24.9431 46.3499 25.1884L38.2581 37.5705L36.7021 36.5539L44.7939 24.1716C44.9543 23.9261 44.8855 23.5977 44.6401 23.4375L43.1373 22.4555C42.892 22.2952 42.5633 22.364 42.4032 22.6093L30.2873 41.1497C30.2358 41.2285 30.2064 41.3196 30.2016 41.4136L29.8849 47.848C29.8757 48.0359 29.9668 48.2152 30.1245 48.3177C30.2822 48.4208 30.4829 48.4324 30.651 48.3485L36.4168 45.4748C36.5013 45.4331 36.5728 45.3691 36.6245 45.2901L48.7401 26.7499C48.9009 26.5053 48.8319 26.1768 48.5868 26.0164Z" />
                    <path
                        d="M53.5508 18.4193L48.1016 14.8583C47.8565 14.6981 47.5277 14.7669 47.3675 15.0121L43.6924 20.636C43.5323 20.8813 43.6009 21.2101 43.8463 21.3704L49.2955 24.9312C49.5405 25.0915 49.8694 25.0227 50.0296 24.7773L53.7045 19.1536C53.865 18.9083 53.7961 18.5796 53.5508 18.4193Z" />
                    <path
                        d="M11.1419 11.6616H21.5419C22.2783 11.6616 22.8753 11.0645 22.8753 10.3283C22.8753 9.59199 22.2783 8.99492 21.5419 8.99492H11.1419C10.4055 8.99492 9.80859 9.59199 9.80859 10.3283C9.80859 11.0645 10.4058 11.6616 11.1419 11.6616Z" />
                    <path
                        d="M30.8753 16.9949C30.8753 16.2587 30.2781 15.6616 29.5419 15.6616H11.1419C10.4055 15.6616 9.80859 16.2587 9.80859 16.9949C9.80859 17.7312 10.4055 18.3283 11.1419 18.3283H29.5419C30.2783 18.3283 30.8753 17.7312 30.8753 16.9949Z" />
                    <path
                        d="M11.1419 24.9949H21.5419C22.2783 24.9949 22.8753 24.3979 22.8753 23.6616C22.8753 22.9253 22.2783 22.3283 21.5419 22.3283H11.1419C10.4055 22.3283 9.80859 22.9253 9.80859 23.6616C9.80859 24.3979 10.4058 24.9949 11.1419 24.9949Z" />
                    <path
                        d="M11.1419 31.7167H21.5419C22.2783 31.7167 22.8753 31.1196 22.8753 30.3833C22.8753 29.6472 22.2783 29.05 21.5419 29.05H11.1419C10.4055 29.05 9.80859 29.6472 9.80859 30.3833C9.80859 31.1196 10.4058 31.7167 11.1419 31.7167Z" />
                    <path
                        d="M11.7062 48.9476C11.4466 49.2831 11.9149 49.7585 12.1777 49.4187C13.0061 48.3485 13.6902 47.1959 14.2615 45.9793C14.6181 46.2032 15.0862 46.1584 15.4702 46.0067C16.0237 45.7884 16.4929 45.3672 16.9397 44.986C17.2038 44.7607 17.5113 44.3885 17.8769 44.3529C18.1561 44.3261 18.5331 44.5509 18.8122 44.5988C19.5414 44.7231 20.3931 44.512 21.0971 44.338C21.7653 44.1731 22.5477 43.9121 22.9409 43.3072C23.1759 42.9456 22.5985 42.6117 22.3653 42.9711C22.0505 43.4553 21.2818 43.6063 20.7623 43.7345C20.1526 43.8853 19.4451 44.034 18.8167 43.9268C18.3431 43.8463 17.9601 43.5599 17.4731 43.7768C16.8209 44.0675 16.3226 44.6783 15.7466 45.0907C15.4889 45.2752 15.1943 45.4525 14.8719 45.4775C14.7393 45.4877 14.6311 45.4391 14.5413 45.358C14.6122 45.1935 14.6826 45.0281 14.7497 44.8613C15.3998 43.2475 15.6938 41.6085 15.9955 39.9085C16.1489 39.0447 16.4039 37.6835 15.1658 37.6004C14.0718 37.5273 13.1263 39.1053 12.7767 39.9369C12.4641 40.6807 12.4293 41.5447 12.4531 42.3388C12.4679 42.8337 12.6461 43.3476 12.7774 43.8593C11.7276 44.0277 10.8022 45.0881 10.9644 46.1393C11.124 47.1737 12.4174 46.6396 12.9005 46.2568C13.3894 45.8695 13.5477 45.3856 13.5529 44.8637C13.6503 45.0244 13.7318 45.2171 13.8161 45.3973C13.2527 46.6609 12.5465 47.862 11.7062 48.9476ZM12.8747 45.1741C12.7761 45.6139 12.2197 46.048 11.7815 46.0885C11.4369 46.1205 11.6471 45.5049 11.7153 45.3673C11.9291 44.9351 12.459 44.6529 12.9045 44.5313C12.9253 44.7483 12.9219 44.9632 12.8747 45.1741ZM13.4315 43.8833C13.3181 43.3532 13.1606 42.8208 13.1198 42.3389C13.0409 41.4089 13.2061 40.4344 13.6673 39.6211C13.9554 39.1128 14.5427 38.3339 15.1658 38.2672C15.7222 38.208 15.3829 39.5612 15.3347 39.8331C15.1858 40.6723 15.0795 41.5052 14.8719 42.3348C14.6791 43.1052 14.4349 43.8681 14.1427 44.6141C13.9874 44.2276 13.7851 43.9801 13.4315 43.8833Z" />
                </svg>
                Click here to sign the agreement
            </a>
        </div>

        <!-- Signature Modal -->
        <div v-if="showSignatureModal" class="fixed z-50 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-800 opacity-75"></div>
                </div>

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-xl sm:w-full sm:p-6"
                    role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                        Draw Signature
                    </h3>

                    <div class="hidden sm:block absolute top-0 right-0 pt-5 pr-5">
                        <a href="javascript:void(0);" @click="closeAddSignatureModal()"
                            class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none">
                            <span class="sr-only">Close</span>
                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </a>
                    </div>

                    <div class="mt-3 border border-gray-100 p-2 rounded">
                        <div class="border-b-2 border-gray-400 mb-1">
                            <vue-signature ref="signature" :w="'510px'" :h="'150px'" :sigOption="option"></vue-signature>
                        </div>
                        <div class="text-right">
                            <button @click="clearSignature()"
                                class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-50 mt-1 px-3 rounded-lg text-gray-600 text-xs focus:outline-none">
                                Clear
                            </button>
                            <button @click="undoSignatureLastStroke()"
                                class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-50 mt-1 px-3 rounded-lg text-gray-600 text-xs focus:outline-none">
                                Undo
                            </button>
                        </div>
                    </div>

                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:grid-flow-row-dense">
                        <button type="button" @click="submitHandler()"
                            class="w-full inline-flex justify-center rounded-md border border-transparent  px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm">
                            Sign Agreement
                        </button>
                        <button type="button" @click="closeAddSignatureModal()"
                            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProtestRequestApi from "@/services/api/ProtestRequest.js";
export default {
    props: ["property", "userProperty", "donation-success", "donation-cancel"],
    data() {
        return {
            showSignatureModal: false,
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)",
                border: "1px solid",
                w: "400px",
            },
            signature: "",
        };
    },
    computed: {
        siteUrl: function () {
            return document.location.origin;
        },
    },
    created() {
        let steps = ['step4'];

        let previousUrl = document.referrer;
        if (previousUrl.includes(steps)) {
            window.history.pushState(null, "");
            window.onpopstate = function () {
                window.history.pushState(null, "");
            };
        }
    },
    methods: {
        checkIfAlreadySigned(){

        },
        openAddSignatureModal() {
            this.showSignatureModal = true;
        },

        closeAddSignatureModal() {
            this.showSignatureModal = false;
        },
        submitHandler() {
            this.signature = this.$refs.signature.save("image/png");

            if (this.$refs.signature.isEmpty()) {
                alert("Please add signature");
                return;
            }

            ProtestRequestApi.updateSignature(
                this.signature,
                this.userProperty.uid
            ).then((res) => {
                if (res.data.error == false) {
                    this.closeAddSignatureModal();
                    window.location.reload();
                } else {
                    window.location.reload();
                }
            });
        },
        clearSignature() {
            var _this = this;
            _this.$refs.signature.clear();
        },
        undoSignatureLastStroke() {
            var _this = this;
            _this.$refs.signature.undo();
        },
    },
};
</script>
